import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import CommonButtonId from '../../components/atoms/CommonButtonId';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  bookingMess: {
    whiteSpace: 'break-spaces'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      bookings: state.bookings.list.list,
      totalCount: state.bookings.list.totalCount
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    bookings,
    totalCount,
    rowsPerPage,
    onChangeBookingStatus,
    page,
    handleChangePage,
    setRowsPerPage
  }) => {
    const onClickChangeStatus = id => {
      const ids = [];
      ids.push(id);
      onChangeBookingStatus(ids);
    };

    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>連絡番号</TableCell>
                <TableCell>状況</TableCell>
                <TableCell>連絡操作</TableCell>
                <TableCell>連絡があった日</TableCell>
                <TableCell>来店希望日</TableCell>
                <TableCell>連絡者名</TableCell>
                <TableCell>電話番号</TableCell>
                <TableCell>領収書番号</TableCell>
                <TableCell>店舗ID</TableCell>
                <TableCell>グループ名</TableCell>
                <TableCell>店舗名</TableCell>
                <TableCell>メニュー名</TableCell>
                <TableCell>税込価格</TableCell>
                <TableCell>メッセージ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bookings &&
                bookings.map(booking => (
                  <TableRow>
                    <TableCell>{booking.bookingId}</TableCell>
                    <TableCell>
                      {(() => {
                        if (booking.status === 'WAITING') return '進行中';
                        return '完了';
                      })()}
                    </TableCell>
                    <TableCell>
                      <CommonButtonId
                        id={booking.bookingId}
                        className={classes.button}
                        title="お客様に連絡する"
                        disabled={booking.status === 'FINISHED'}
                        onClickAction={() =>
                          onClickChangeStatus(booking.bookingId)
                        }
                      />
                    </TableCell>
                    <TableCell>{booking.createdAt}</TableCell>
                    <TableCell>{booking.bookingTime}</TableCell>
                    <TableCell>{booking.bookingUsername}</TableCell>
                    <TableCell>{booking.phoneNumber}</TableCell>
                    <TableCell>{booking.gochiBillNo}</TableCell>
                    <TableCell>{booking.shopId}</TableCell>
                    <TableCell>{booking.groupName}</TableCell>
                    <TableCell>{booking.shopName}</TableCell>
                    <TableCell>{booking.menuName}</TableCell>
                    <TableCell>{booking.includedTaxPrice}</TableCell>
                    <TableCell className={classes.bookingMess}>
                      {booking.bookingMessage}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={page}
          handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
